<template>
  <div class="card-container">
    <div class="flex-row vertical-center flow-justify">
      <el-button type="default" class="button-size" @click="$router.go(-1)"
        >返回上一级</el-button
      >
    </div>

    <el-row class="flow-justify plan-label flow-wrap">
      <p>
        总金额（元）：<span>{{ toDoubleThousands(notice.repayTotalAmt) }}</span>
      </p>
      <p>
        待退还金额（元）：<span>{{
          toDoubleThousands((notice.qpayAmt * 100) / 10000)
        }}</span>
      </p>
      <p>
        总天数（天）：<span>{{ notice.repayDays || 0 }}</span>
      </p>
      <p>
        总笔数（笔）：<span>{{ notice.repayCount || 0 }}</span>
      </p>
      <p>
        已执行还款笔数（笔）：<span>{{ notice.repayCountExcute || 0 }}</span>
      </p>
      <p>
        已消费金额（元）：<span>{{ toDoubleThousands(consumeMoney) }}</span>
      </p>
      <p v-if="notice.status">
        计划状态：<span>{{
          notice.status == 3
            ? stopStatus[notice.repayType + 1].dictValue +
              "-" +
              refundStatus[notice.refundStatus + 1].dictValue
            : status[notice.status + 1].dictValue
        }}</span>
      </p>
    </el-row>

    <common-table
      :data="tableData"
      :isShow="false"
      ref="commonTable"
      @handleChange="getList"
      class="common"
    >
      <el-table-column
        prop="chnShortName"
        label="通道编码"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column prop="repayType" label="任务类型" show-overflow-tooltip>
        <template slot-scope="scope">
          <p :class="scope.row.repayType == 1 ? 'text-green' : 'text-red'">
            {{ scope.row.repayType == 1 ? "消费" : "还款" }}
          </p>
        </template>
      </el-table-column>
      <el-table-column
        prop="tranAmt"
        label="交易金额"
        show-overflow-tooltip
        :formatter="formatterTableNumber"
      ></el-table-column>
      <el-table-column
        prop="serverFee"
        label="服务费"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterTableNumber"
      ></el-table-column>
      <el-table-column
        prop="repayDate"
        label="还款日期"
        min-width="100"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="repayTime"
        label="还款时间"
        min-width="100"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="executeTime"
        label="执行时间"
        min-width="130"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="errmsg"
        label="响应信息"
        min-width="100"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        min-width="80"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <p
            class="blue-text table-text-button"
            @click.self="handleGoRepay(scope.row)"
          >
            {{ planDetailStatus[scope.row.status].text }}
          </p>
          <!--<p class="table-text-button" v-else>{{planDetailStatus[scope.row.status].text}}</p>-->
        </template>
      </el-table-column>
    </common-table>
    <show-info-dialog ref="showInfoDialog" title="详细信息">
      <common-table :data="repayInfo" :isShow="false">
        <el-table-column
          prop="odrNo"
          label="订单号"
          min-width="160"
          show-overflow-tooltip
          :formatter="formatterTableData"
        ></el-table-column>
        <el-table-column
          prop="chMerCode"
          label="商户号"
          min-width="160"
          show-overflow-tooltip
          :formatter="formatterTableData"
        ></el-table-column>
        <el-table-column
          prop="odrAmt"
          label="交易金额"
          min-width="100"
          show-overflow-tooltip
          :formatter="formatterTableNumber"
        ></el-table-column>
        <el-table-column
          prop="odrFee"
          label="服务费"
          min-width="100"
          show-overflow-tooltip
          :formatter="formatterTableNumber"
        ></el-table-column>
        <el-table-column
          prop="createTime"
          label="创建时间"
          min-width="160"
          show-overflow-tooltip
          :formatter="formatterTableData"
        ></el-table-column>
        <el-table-column
          prop="status"
          label="订单状态"
          min-width="100"
          show-overflow-tooltip
          :formatter="formatterInfoStatus"
        ></el-table-column>
        <el-table-column
          prop="resMsg"
          label="响应信息"
          min-width="160"
          show-overflow-tooltip
          :formatter="formatterTableData"
        ></el-table-column>
        <el-table-column
          prop="updateTime"
          label="响应时间"
          min-width="160"
          show-overflow-tooltip
          :formatter="formatterTableData"
        ></el-table-column>
      </common-table>
    </show-info-dialog>
  </div>
</template>

<script>
import CommonTable from "components/common/CommonTable";
import ShowInfoDialog from "@/view/dialog/ShowInfoDialog";
import OrganService from "service/OrganService";
import ChannelRateService from "service/ChannelRateService";
import TransactionService from "service/TransactionService";
import ExitRepayStatus from "service/constant/ExitRepayStatus";
import privateKey from "service/constant/privateKey";
import planDetailStatus from "service/constant/planDetailStatus";
import RefundStatus from "service/constant/RefundStatus";
import StopStatus from "service/constant/StopStatus";
import EmptyStatus from "service/constant/EmptyStatus";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "PlanDetails",
  data() {
    return {
      notice: {},
      tableData: [],
      repayInfo: {},
      page: {},
      status: EmptyStatus,
      stopStatus: StopStatus,
      refundStatus: RefundStatus,
      planDetailStatus: planDetailStatus,
      planStatus: [],
      showBut: false,
      currentStatus: "",
      consumeMoney: 0,
      ExitRepayStatus: ExitRepayStatus,
    };
  },
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  components: {
    CommonTable,
    ShowInfoDialog,
  },
  mounted() {
    // this.page = this.$refs.commonTable.page;
    this.getList();
    this.getInfo();

    this.getTypeNames("计划状态", (res) => {
      this.planStatus = res;
    });
  },
  computed: {
    commonParams() {
      const params = {
        userId: this.userId,
        planId: this.$route.params.id,
        repayPlanId: this.$route.params.id,
      };
      return params;
    },
    ...mapGetters(["serverType", "tatId", "userId"]),
  },
  inject: ["reload", "addTab"],
  methods: {
    handleGoRepay(repayType) {
      this.doLoad(
        TransactionService.getOrderList,
        {
          planId: this.$route.params.id,
          itemId: repayType.id,
          type: repayType.repayType,
        },
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            this.repayInfo = result;

            this.$nextTick(() => {
              this.$refs.showInfoDialog.open();
            });
          });
        },
        "信息获取失败"
      );
    },
    formatTranTypee(row, column, cellValue) {
      let value = "";
      value = this.planDetailStatus[cellValue].text;
      return value ? value : "--";
    },
    formatterInfoStatus(row, column, cellValue) {
      return this.ExitRepayStatus[cellValue] || "--";
    },
    getList() {
      this.doLoad(
        TransactionService.getPlanDtl,
        this.commonParams,
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            this.tableData = result;
            let arr = [];
            this.tableData.forEach((item) => {
              if (item.status != 1) {
                arr.push(item.status);
              }
              if (item.repayType == 1 && item.status == 2) {
                // 还款
                this.consumeMoney += (item.tranAmt * 100) / 10000;
              }
            });

            this.showBut = arr.length != this.tableData.length;
          });
        },
        "信息获取失败"
      );
    },
    getInfo() {
      this.doLoad(
        TransactionService.getRepayPlanById,
        this.commonParams,
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            // console.log('getRepayPlanById',result);
            this.notice = result;
          });
        },
        "信息获取失败"
      );
    },
  },
};
</script>

<style scoped>
.plan-label {
  /*padding-left: 10%;*/
}

.plan-label p {
  margin: 10px 10px 20px;
}

.plan-label p span {
  color: rgba(170, 170, 170, 1);
}

.button-size {
  width: 120px;
  margin-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/view/page/TransactionManage/PlanDetails.vue